import { render } from "./manage-supplier.vue?vue&type=template&id=22dd66f5"
import script from "./manage-supplier.vue?vue&type=script&lang=js"
export * from "./manage-supplier.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__